import DaysBarChart from "./bar-chart/days-bar-chart";
import { useContext } from "react";
import { JourneysContext } from "../../context/journeys-context";
import { formatDateFromTimestampAndAddMilliseconds } from "../../utils/helpers";
import HomepageCard from "./homepage-card";

const NextFiveDays = () => {
  const { businessDaysUntilFutureTimeout, futureJourneyTimeout, inProgressJourneyTimeout } =
    useContext(JourneysContext);

  let message;
  if (futureJourneyTimeout) {
    message = (
      <span>
        Your upcoming cadence pause is starting in {businessDaysUntilFutureTimeout} business days on{" "}
        <strong>{formatDateFromTimestampAndAddMilliseconds(futureJourneyTimeout.pause_start, true)}.</strong>
      </span>
    );
  } else if (inProgressJourneyTimeout) {
    message = (
      <span>
        Your cadence steps are currently paused and will resume on{" "}
        <strong>{formatDateFromTimestampAndAddMilliseconds(inProgressJourneyTimeout.pause_end, true)}.</strong>
      </span>
    );
  }

  return (
    <HomepageCard
      leftHeading={"Your Next 5 Days"}
      rightHeading={"Based on your scheduled cadence steps"}
      headingRow={false}
      body={
        <>
          {message}
          <div className="chart-wrapper">
            <DaysBarChart />
          </div>
        </>
      }
    />
  );
};

export default NextFiveDays;
